<template>
	<section>
		<h3>Display Settings</h3>

		<p>Customize what appears on the purchase order PDF.</p>

		<field label="Show Pricing"
			col-class="col-sm-6 col-md-6"
			:params="{type:'boolean'}"
			:readonly="isFinalized"
			v-model="localSettings.showPricing"
			v-on:change="saveSettings">
		</field>
	</section>
</template>
<script type="text/javascript">
import Field from "@/components/Field"

export default {
	name: "PurchaseOrderDisplaySettings",
	components: {
		Field
	},
	props: [
		"documentSettings",
		"isFinalized"
	],
	data() {
		return {
			localSettings: {
				showDescription: true,
				showPricing: true
			}
		}
	},
	watch: {
		documentSettings() {
			this.setLocalSettings()
		}
	},
	methods: {
		setLocalSettings() {
			let settings = this.documentSettings || {}

			this.$set(this.localSettings, "showDescription", settings.showDescription != false)
			this.$set(this.localSettings, "showPricing", settings.showPricing != false)
		},
		saveSettings() {
			let vm = this

			this.$nextTick(() => {
				vm.$emit("settingsChange", vm.localSettings)
			})
		}
	},
	created() {
		this.setLocalSettings()
	}
}
</script>
